import React from 'react';
import styled from 'styled-components';
import { LFC } from '../Legacy';


export const SpotLoader: LFC<{ margin?: string, color?: string }> = ({ margin, color }) =>
    <Spinner margin={margin}>
        <Bouncer mode="A" color={color ?? 'white'} />
        <Bouncer mode="B" color={color ?? 'white'} />
    </Spinner>;

const Spinner = styled.div<{ margin?: string }>`
    width: 4rem;
    height: 4rem;

    position: relative;
    margin: ${p => p.margin ?? '10rem auto'};
`;

const Bouncer = styled.div<{ mode: 'A' | 'B', color: string }>`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${p => p.color};
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;

    @keyframes sk-bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        } 50% {
            transform: scale(1.0);
            -webkit-transform: scale(1.0);
        }
    }

    animation: sk-bounce 2.0s infinite ease-in-out;
    animation-delay: ${p => p.mode === 'A' ? '0' : '-1.0s'};
`;
